import { Close, AccountCircle } from '@mui/icons-material';
import { Modal, Typography, Grid, Paper } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import COLOR from 'utils/constants/color';
import moment  from 'moment';
import styled, { } from 'styled-components';
import { Avatar } from 'antd';
import { getAvatar } from "utils/assets/images/lootie";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useState } from "react"






import { find, get, map } from "lodash"

const UserList = styled.div`
    min-height: 40px;
    width: 100%;
    font-size: 12px;
    position: relative;
    margin-top: 10px;
    background: transparent;
    border: none;
    color: #fff;
    text-align: left;
    display:flex;
    flex-direction:row;
    font-size: 12px;
    text-transform: capitalize;
    align-items: center;
`;

const UserModal = styled.div`
    left: 50%;
    max-width: 400px;
    padding: 0px 24px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
`;
const UserPopUpArea = styled.div`
    background-color: rgb(82,84,82);
    border-radius: 10px;
    padding-right: 0px;
    padding-left: 10px;
    position:relative;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 768px){
        padding: 15px;
    }
`;
const CloseBtn = styled.div`
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    right: 0px;
    color: white;
    z-index: 1;
`;
const UserArea = styled.div`
    display:flex;
    flex-direction:column;
    overflow:auto;
    overflow-x:hidden;
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    flex-direction:row;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    max-height: 70vh;
    padding: 10px;
`;
const UserRow = styled.div`
    display: flex;
    align-items: center;
    flex-direction:row;
    width:100%;
    position: relative;
`;
const AvtarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content:center;
    position:relative;
    width: 30px;
    height: 30px;
    border-radius: 50%;
`;
const NameCol = styled.div`
    display: flex;
    align-items: center;
    width:83%;
    flex-direction:column;
    @media (max-width: 768px) { 
      width: 88%;
      margin-right: 12px;
    }  
`;
const NameInnerRow = styled.div`
    display: flex;
    width:100%;
    color: #fff;
    font-weight: bold;
`;


const StyledTypography = muiStyled(Typography)(({ theme }) => ({
    fontWeight: 400,
    color: 'rgb(255, 255, 255)',
    fontSize: 20,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 17
}));

const StyledUserIcon = muiStyled(AccountCircle)(({ theme }) => ({
    color: COLOR.white,
    fontSize: '30px',
    marginRight: '5px'
}));

const StyledPaper = muiStyled(Paper)(({ theme }) => ({
    padding: '4px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledGrid = muiStyled(Grid)(() => ({
    background: "transparent"
}));

const StyledCloseIcon = muiStyled(Close)(({ theme }) => ({
    color: COLOR.white,
    fontWeight: "bolder",
    fontSize: '20px',
    position: 'absolute',
    right: '-5px',
    top: '-5px',
    background: 'red',
    borderRadius: '50%'
}));

export const MessageSeenModal = ({ classUsers, seenUsers, deliverdUsers, showModal, closeModal }) => {
    const [seenUser, setSeenUser] = useState([])
    const [deliveredUser, setdeliveredUser] = useState([])
    const [undeliverdUser, setUndeliverdUser] = useState([])

    const getUserIcon = (usr) => {
        const avatar = getAvatar(get(usr, "config.avatar"))
        return (avatar ? <Avatar size={30} src={avatar} /> : <StyledUserIcon />)
    }

    useEffect(() => {
        const _seenUser = []
        const _deliveredUser = []
        const _undeliverdUser = []
        map(classUsers, cu => {
            const hasSeen = find(seenUsers, ["id", get(cu, "id")])
            const hasDeliverd = find(deliverdUsers, ["id", get(cu, "id")])
            if (hasSeen) {
                _seenUser.push({ ...cu, ...hasSeen })
            } else if (hasDeliverd) {
                _deliveredUser.push({ ...cu, ...hasDeliverd })
            } else {
                _undeliverdUser.push(cu)
            }
            setSeenUser(_seenUser)
            setdeliveredUser(_deliveredUser)
            setUndeliverdUser(_undeliverdUser)
        })
    }, [classUsers, seenUsers, deliverdUsers])
    const renderSeenDeliverd = (usr, type, date) => {
        return (<UserList key={get(usr, "id")}>
            <UserRow>
                <AvtarContainer>
                    {getUserIcon(usr)}
                </AvtarContainer>
                <NameCol>
                    <NameInnerRow style={{ color: COLOR.white, paddingLeft: 5 }}>  {get(usr, "lastName", "")} ,  {get(usr, "firstName", "")}  </NameInnerRow>
                    {date&&<NameInnerRow style={{ color: COLOR.white, paddingLeft: 5 , fontSize:10, fontWeight:'200' , textTransform:"lowercase" }}>{moment(date).format("MM-DD-YYYY   hh:mm a")} </NameInnerRow>}
                </NameCol>
            </UserRow>
        </UserList>)
    }
    return (<>
        <Modal
            open={showModal}
            onClose={closeModal}
            style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
            className="avtarModl">
            <UserModal className="avtarUsrModl" style={{padding:10}}>
                <UserPopUpArea className="avtarUsrArea">
                    <CloseBtn onClick={closeModal}>
                        <StyledCloseIcon />
                    </CloseBtn>
                    <UserArea>
                        <StyledGrid sx={{width: '100%'}}  container>
                            {seenUser.length > 0 && <StyledGrid sx={{width: '50%'}} item xs={24} >
                                <StyledPaper style={{ background: "transparent" }} elevation={0}>
                                    <StyledTypography variant="h4">Seen</StyledTypography>
                                    {map(seenUser, usr => {
                                        return renderSeenDeliverd(usr, "seen", get(usr, "readAt"))
                                    })}
                                </StyledPaper>
                            </StyledGrid>}
                            {deliveredUser.length > 0 && <StyledGrid sx={{width:'50%'}} item xs={12}>
                                <StyledPaper style={{ background: "transparent" }} elevation={0}>
                                    <StyledTypography variant="h4">Delivered</StyledTypography>
                                    {map(deliveredUser, usr => {
                                        return renderSeenDeliverd(usr, "delivered", get(usr, "deliverAt"))
                                    })}
                                </StyledPaper>
                            </StyledGrid>}
                            {undeliverdUser.length > 0 && <StyledGrid sx={{width:'50%'}} item xs={12}>
                                <StyledPaper style={{ background: "transparent" }} elevation={0}>
                                    <StyledTypography variant="h4">Unseen</StyledTypography>
                                    {map(undeliverdUser, usr => {
                                        return renderSeenDeliverd(usr, "undelived", null)
                                    })}
                                </StyledPaper>
                            </StyledGrid>}
                        </StyledGrid>
                    </UserArea>
                </UserPopUpArea>
            </UserModal>
        </Modal>
    </>)
}